import { Injectable } from '@angular/core';
import { TranslocoMissingHandler } from '@ngneat/transloco';

@Injectable({ providedIn: 'root' })
export class CustomMissingHandler implements TranslocoMissingHandler {
  handle(key: string) {
    return key;
  }
}